import type {
  CreateDraftContractPayload,
  CreateDraftContractResponse,
} from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { vestigasApi } from '~/services/kyClient';

import { mapEmptyContractDatesToNull } from '../validations';

import {
  zodCreateDraftContractPayloadSchema,
  zodCreateDraftContractResponseSchema,
} from './validations';

/**
 * Creates a draft contract without items. The API marks it as not yet saved
 * until its header is saved or it is confirmed; until then it is left out of
 * the contract list.
 *
 * @param payload - The header fields known when the draft is started.
 * @returns The created draft contract.
 * @throws Error if the API request fails or validation fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/create_draft_contract_contracts_drafts_post
 */
export const createDraftContract = async (
  payload: CreateDraftContractPayload,
) => {
  return await vestigasApi
    .post(ENDPOINT.CONTRACT.CREATE_DRAFT(), {
      json: payload,
      validate: {
        body: zodCreateDraftContractPayloadSchema.transform(
          mapEmptyContractDatesToNull,
        ),
        response: zodCreateDraftContractResponseSchema,
      },
    })
    .json<CreateDraftContractResponse>();
};
